import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import {
    Grid,
    Tab,
    Tabs,
    Typography,
} from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import { ClientPassportAgreementsTable } from "../CustomerPage/Passport/tables/ClientPassportAgreementsTable";
import { ClientPassportContactsTable } from "../CustomerPage/Passport/tables/ClientPassportContactsTable";
import { ClientPassportBookingsTable } from "../CustomerPage/Passport/tables/ClientPassportBookingsTable";
import { ClientPassportOffersTable } from "../CustomerPage/Passport/tables/ClientPassportOffersTable";
import { ClientPassportLeadsTable } from "../LeadsPage/ClientPassportLeadsTable";
import { ClientPassportTasksTable } from "../CustomerPage/Passport/tables/ClientPassportTasksTable";
import { TABLE_TEXT_FIELD_MAX_EXTEND_LENGTH } from "../../helpers/constants";

function LeadsContactsOffersAgrementsTabs(props) {
const [tab, setTab] = useState("leads");

  return (
    <TabContext value={tab}>
        <Tabs
            variant="fullWidth"
            value={tab}
            onChange={(e, newValue) => setTab(newValue)}
        >
            <Tab value={"leads"} label={t("contacts.dialog.tabs.leads")} />
            <Tab value={"contacts"} label={t("contacts.dialog.tabs.contacts")} />
            <Tab value={"bookings"} label={t("contacts.dialog.tabs.bookings")} />
            <Tab value="offers" label={t("contacts.dialog.tabs.offers")} />
            <Tab value="agreements" label={t("contacts.dialog.tabs.agreements")} />
            <Tab value="tasks" label={t("contacts.dialog.tabs.tasks")} />
        </Tabs>
        <TabPanel value={"leads"} sx={{ p: 0 }}>
            <Grid
                item
                xs
                sx={{
                    bgcolor: "whitesmoke",
                    borderRadius: 2,
                    p: 2,
                }}
            >
                <ClientPassportLeadsTable
                    relatedLeadsForClientId={props.customerId}
                    personId={props.personId}
                    disableEdit={true}
                    colMaxLength={TABLE_TEXT_FIELD_MAX_EXTEND_LENGTH}
                    maxHeight={400}
                />
            </Grid>
        </TabPanel>
        <TabPanel value={"contacts"} sx={{ p: 0 }}>
            <Grid
                item
                xs
                sx={{
                    bgcolor: "whitesmoke",
                    borderRadius: 2,
                    p: 2,
                }}
            >
                <ClientPassportContactsTable relatedContactsForClientId={props.customerId} personId={props.personId} colMaxLength={TABLE_TEXT_FIELD_MAX_EXTEND_LENGTH} maxHeight={400}/>
            </Grid>
        </TabPanel>
        <TabPanel value="offers" sx={{ p: 0 }}>
            <Grid
                item
                xs
                sx={{
                    bgcolor: "whitesmoke",
                    borderRadius: 2,
                    p: 2,
                }}
            >
                {props.customerId ? (
                    <ClientPassportOffersTable customerId={props.customerId} colMaxLength={TABLE_TEXT_FIELD_MAX_EXTEND_LENGTH} maxHeight={400}/>
                ) : (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ p: 2 }}
                    >
                        {t("contacts.dialog.noCustomerData")}
                    </Typography>
                )}
            </Grid>
        </TabPanel>
        <TabPanel value="bookings" sx={{ p: 0 }}>
            <Grid
                item
                xs
                sx={{
                    bgcolor: "whitesmoke",
                    borderRadius: 2,
                    p: 2,
                }}
            >
                {props.customerId ? (
                    <ClientPassportBookingsTable customerId={props.customerId} colMaxLength={TABLE_TEXT_FIELD_MAX_EXTEND_LENGTH} maxHeight={400}/>
                ) : (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ p: 2 }}
                    >
                        {t("contacts.dialog.noCustomerData")}
                    </Typography>
                )}
            </Grid>
        </TabPanel>
        <TabPanel value="agreements" sx={{ p: 0 }}>
            <Grid
                item
                xs
                sx={{
                    bgcolor: "whitesmoke",
                    borderRadius: 2,
                    p: 2,
                }}
            >
                {props.customerId ? (
                    <ClientPassportAgreementsTable customerId={props.customerId} colMaxLength={TABLE_TEXT_FIELD_MAX_EXTEND_LENGTH} maxHeight={400}/>
                ) : (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ p: 2 }}
                    >
                        {t("contacts.dialog.noCustomerData")}
                    </Typography>
                )}
            </Grid>
        </TabPanel>
        <TabPanel value="tasks" sx={{ p: 0 }}>
            <Grid
                item
                xs
                sx={{
                    bgcolor: "whitesmoke",
                    borderRadius: 2,
                    p: 2,
                }}
            >
                {props.customerId ? (
                    <ClientPassportTasksTable relatedTasksForClientId={props.customerId} customerId={props.customerId} colMaxLength={TABLE_TEXT_FIELD_MAX_EXTEND_LENGTH} maxHeight={400}/>
                ) : (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ p: 2 }}
                    >
                        {t("contacts.dialog.noCustomerData")}
                    </Typography>
                )}
            </Grid>
        </TabPanel>
        <TabPanel value="contracts" sx={{ p: 0 }}>
            <Grid
                item
                xs
                sx={{
                    bgcolor: "whitesmoke",
                    borderRadius: 2,
                    p: 2,
                }}
            >
                {/* TODO: Add contracts table when available */}
                <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
                    {t("contacts.dialog.contractsComingSoon")}
                </Typography>
            </Grid>
        </TabPanel>
    </TabContext>
  )
}

export default LeadsContactsOffersAgrementsTabs